import { render } from "./LeagueRankingView.vue?vue&type=template&id=cd4e5ffe&scoped=true"
import script from "./LeagueRankingView.vue?vue&type=script&lang=js"
export * from "./LeagueRankingView.vue?vue&type=script&lang=js"

import "./LeagueRankingView.vue?vue&type=style&index=0&id=cd4e5ffe&lang=scss"
import "./LeagueRankingView.vue?vue&type=style&index=1&id=cd4e5ffe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd4e5ffe"]])

export default __exports__